export const PRODUCT_VERTICAL_MAP = {
    1: "Learn",
    2: "SCA",
    4: "SCHOOLS",
    5: "NON_IL_SCA",
};
export const getProductVertical = (id) => {
    if (!id)
        return "";
    const numericId = Number(id);
    return PRODUCT_VERTICAL_MAP[numericId] ?? "";
};
